import React from "react";
import { Star, Quote } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import SectionHeading from "../components/site/SectionHeading";
import ReviewBadge from "../components/site/ReviewBadge";

const Reviews = () => {
  const { t } = useLang();
  return (
    <div data-testid="page-reviews">
      <section className="pt-40 pb-20 border-b border-white/5">
        <div className="container-x flex flex-col items-start gap-8">
          <SectionHeading overline={t.reviews.overline} title={t.reviews.title} subtitle={t.reviews.subtitle} />
          <ReviewBadge />
        </div>
      </section>

      <section className="section-y">
        <div className="container-x grid md:grid-cols-3 gap-5">
          {t.reviews.items.map((r, i) => (
            <div
              key={i}
              className="hairline rounded-xl p-8 bg-[#141417] relative overflow-hidden card-lift"
              data-testid={`review-${i}`}
            >
              <Quote className="absolute top-6 right-6 w-10 h-10 text-[#0055FF]/20" />
              <div className="flex items-center gap-0.5 text-[#0055FF]">
                {[0,1,2,3,4].map(n => <Star key={n} className="w-4 h-4 fill-current" />)}
              </div>
              <p className="mt-6 text-white/80 leading-relaxed text-[15px]">“{r.text}”</p>
              <div className="mt-8 pt-6 border-t border-white/10">
                <div className="font-display text-white">{r.name}</div>
                <div className="text-xs text-white/55 tracking-[0.18em] uppercase mt-1">{r.role}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="border-t border-white/5 bg-[#0C0C0F]">
        <div className="container-x py-20 text-center">
          <div className="font-display text-7xl font-extralight text-white">5.0</div>
          <div className="mt-3 text-white/60">Average rating across 2,387 verified reviews</div>
        </div>
      </section>
    </div>
  );
};

export default Reviews;
